export const AppGlobal = {
  angularDateFormat: 'dd.MM.yyyy',
  momentDateFormat: 'DD.MM.YYYY',
  angularTimeFormat: 'HH:mm',
  angularDateTimeFormat: 'dd.MM.yyyy HH:mm',
};
